module.exports = __webpack_public_path__ + "static/media/ourMissionImage.ece29ac4.svg";